// extracted by mini-css-extract-plugin
export var content = "PageContent-module--content--8760g";
export var header = "PageContent-module--header--q4RcM";
export var label = "PageContent-module--label--uxSR+";
export var nav = "PageContent-module--nav--hnki5";
export var navItem = "PageContent-module--navItem--238Qj";